import { DailyScheduleSlotEntity } from "@/modules/boxDashboard/modules/DailySchedule/entities/dailyScheduleSlotEntity"
import { useServicesContext } from "@modules/core/services/services.context"
import { useQueryClient, useSuspenseQuery } from "@tanstack/react-query"

export const DAILY_SCHEDULE_QUERY_KEY = ["dailySchedule"] as const

export const useDailySchedule = () => {
  const { boxDashboardApi } = useServicesContext()

  const { data, error, refetch } = useSuspenseQuery({
    queryKey: DAILY_SCHEDULE_QUERY_KEY,
    queryFn: async () => {
      const dtos = await boxDashboardApi.getDailySchedule()
      return dtos.map((dto) => DailyScheduleSlotEntity.fromDto(dto))
    },
  })

  return {
    slots: data,
    error,
    refetch,
  }
}

export const useRefreshDailySchedule = () => {
  const queryClient = useQueryClient()

  return () => {
    void queryClient.invalidateQueries({ queryKey: DAILY_SCHEDULE_QUERY_KEY })
  }
}
